import * as React from "react";
const SvgBigOrangeWatch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#F97315"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="m23.152 22.417-4.306-2.57c-.75-.444-1.36-1.514-1.36-2.389v-5.695M31.888 18c0 7.667-6.222 13.89-13.89 13.89-7.667 0-13.89-6.223-13.89-13.89S10.332 4.11 18 4.11 31.89 10.333 31.89 18"
    />
  </svg>
);
export default SvgBigOrangeWatch;
